module.exports = __webpack_public_path__ + "static/media/second_declension_masc_img.276858bf.JPG";